import { LoadingIcon } from "@/components/icons";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon";
import { cn } from "@/utils/utils";
import React from "react";

function NextControlButton({
	className,
	loading,
	onClick,
	dissable,
}: {
	className?: string;
	loading?: boolean;
	dissable?: boolean;
	onClick?: () => void;
}) {
	return (
		<div
			onClick={() => {
				!loading && !dissable && onClick?.();
			}}
			className={cn(
				"   w-7 h-7 flex items-center justify-center bg-white rounded cursor-pointer p-1",
				{
					"cursor-not-allowed": dissable,
				},
				className
			)}>
			{loading ? (
				<LoadingIcon className="w-5 h-5"></LoadingIcon>
			) : (
				<ChevronRightIcon className="text-red-500" />
			)}
		</div>
	);
}

export default NextControlButton;
